import { render, staticRenderFns } from "./card-branch-popup-maps.vue?vue&type=template&id=2c188e96&scoped=true"
import script from "./card-branch-popup-maps.vue?vue&type=script&lang=js"
export * from "./card-branch-popup-maps.vue?vue&type=script&lang=js"
import style0 from "./card-branch-popup-maps.vue?vue&type=style&index=0&id=2c188e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c188e96",
  null
  
)

export default component.exports